{
  "verse": {
    "loading": "جارٍ تحميل الآية...",
    "error": "تعذّر تحميل الآية",
    "reference": "— سورة {{surah}}، آية {{ayah}}",
    "arabicUnavailable": "(العربية غير متاحة)",
    "english": "English",
    "arabic": "العربية",
    "swapLanguage_aria": "تبديل اللغة",
    "toggleLanguage_title": "التبديل بين الإنجليزية والعربية",
    "reflect": "تأمّل",
    "reflecting": "جارٍ التفكير…",
    "reflect_aria": "أنشئ تأمّلًا شخصيًا يربط هذه الآية بنيّتك",
    "insights": "رؤى",
    "insights_aria": "افتح رؤى القرآن بالذكاء الاصطناعي",
    "share": "مشاركة",
    "share_aria": "شارك هذه الآية كصورة",
    "share_title": "شارك هذه الآية",
    "removeFromFavorites_aria": "إزالة من المفضّلة",
    "saveToFavorites_aria": "حفظ في المفضّلة",
    "favoritesProLocked_aria": "المفضّلة ميزة في Pro",
    "favoritesUpgrade_aria": "ترقَّ لحفظ المفضّلة",
    "signInToSave": "سجّل الدخول لحفظ المفضّلة.",
    "failedToUpdateFavorites": "تعذّر تحديث المفضّلة",
    "couldNotReflect": "تعذّر إنشاء التأمّل",
    "shareCaption": "\"{{text}}\"\n— سورة {{surah}}، آية {{ayah}}\n\nrhemn.com",
    "imageSavedVerseCopied": "حُفظت الصورة · نُسخت الآية",
    "imageSaved": "حُفظت صورة الآية",
    "couldNotCreateImage": "تعذّر إنشاء الصورة"
  },
  "insights": {
    "panel_aria": "لوحة رؤى القرآن",
    "title": "رؤى",
    "reference": "سورة {{surah}}، آية {{ayah}}",
    "close_aria": "إغلاق لوحة الرؤى",
    "versePreview_aria": "معاينة الآية",
    "back_aria": "رجوع",
    "tryAgain": "إعادة المحاولة",
    "backTo_aria": "رجوع إلى {{ref}}",
    "copyVerse_aria": "نسخ {{ref}}",
    "openingVerse": "جارٍ فتح الآية…",
    "verseError": "تعذّر فتح الآية."
  },
  "proGate": {
    "title": "رؤى القرآن بالذكاء الاصطناعي ميزة في Pro",
    "subtitleSafari": "افتح فهمًا عميقًا وسياقيًا لكل آية مع Rhemn Pro. عضو بالفعل؟ يُفتح تلقائيًا عند تسجيل الدخول.",
    "subtitle": "افتح فهمًا عميقًا وسياقيًا لكل آية.",
    "bulletAsk": "اسأل أي سؤال عن الآية",
    "bulletTafsir": "ملخّصات تفسير فورية بالذكاء الاصطناعي",
    "bulletRelated": "اكتشف آيات مرتبطة بالموضوع",
    "upgrade": "الترقية إلى Pro"
  },
  "ask": {
    "heading": "اسأل",
    "suggestion1": "ما السياق الأوسع لهذه الآية؟",
    "suggestion2": "كيف أطبّق هذا في حياتي اليومية؟",
    "suggestion3": "ماذا قال العلماء الأوائل عن هذا؟",
    "placeholder": "اسأل أي شيء عن هذه الآية…",
    "input_aria": "اطرح سؤالًا عن هذه الآية",
    "submit_aria": "إرسال السؤال",
    "submit_title": "إرسال (⌘↵)",
    "submit_label": "اسأل",
    "submit_hint": "⌘↵",
    "suggestions_aria": "أسئلة مقترحة",
    "error": "تعذّر الحصول على إجابة.",
    "pending": "نتأمّل في سؤالك…",
    "attribution": "إجابة مُولَّدة بالذكاء الاصطناعي · ليست بديلًا عن العلم الموثوق"
  },
  "tafsir": {
    "heading": "التفسير",
    "emptyText": "احصل على ملخّص تفسير مُولَّد بالذكاء الاصطناعي لهذه الآية.",
    "generate": "إنشاء التفسير",
    "commentary": "شرح",
    "regenerate": "إعادة الإنشاء",
    "regenerate_aria": "إعادة إنشاء التفسير",
    "attribution": "ملخّص مُولَّد بالذكاء الاصطناعي · ليس بديلًا عن العلم الموثوق",
    "error": "تعذّر إنشاء التفسير.",
    "pending": "نقرأ التفسير…"
  },
  "related": {
    "heading": "آيات مرتبطة",
    "copied": "نُسخ: {{ref}}",
    "failedToCopy": "تعذّر النسخ",
    "empty": "لم يُعثر على آيات مرتبطة.",
    "error": "تعذّر تحميل الآيات المرتبطة.",
    "pending": "نبحث عن آيات مرتبطة…"
  },
  "favorites": {
    "panel_aria": "الآيات المفضّلة",
    "title": "الآيات المفضّلة",
    "proLocked": "الآيات المفضّلة ميزة في Pro.",
    "loading": "جارٍ التحميل…",
    "failedToLoad": "تعذّر تحميل المفضّلة",
    "empty": "لا توجد مفضّلة بعد. اضغط القلب على أي آية لحفظها.",
    "reference": "— سورة {{surah}}، آية {{ayah}}",
    "remove_aria": "إزالة من المفضّلة",
    "failedToRemove": "تعذّرت الإزالة"
  }
}
